import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsamcoAuthService } from '@asamco/base';
import { pathJoin } from '@asamco/utils';
import { Observable, from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { MarketPlaceItem } from '../interfaces/market-place-item.interface';
import { skipAuthInterceptor } from '@asamco/utils';

@Injectable({
	providedIn: 'root',
})
export class MarketPlaceItemService {
	url: string = 'linkinformation';

	constructor(private auth: AsamcoAuthService, private http: HttpClient) {}

	public getDataSource(skip: number = 0, top: number = 20, appIds: number[] = null) {
		let ownParams = new HttpParams();

		if (skip > 0) ownParams = ownParams.set('$skip', `${skip}`);

		if (top > 0) ownParams = ownParams.set('$top', `${top}`);

		if (appIds !== null && appIds.length > 0) {
			if (appIds.length === 1) {
				ownParams = ownParams.set(
					'$filter',
					`(FromApplicationId eq ${appIds[0]} or ToApplicationId eq ${appIds[0]}) and showOnMarketplace eq true`
				);
			} else if (appIds.length === 2) {
				ownParams = ownParams.set(
					'$filter',
					`((FromApplicationId eq ${appIds[0]} and ToApplicationId eq ${appIds[1]}) or (FromApplicationId eq ${appIds[1]} and ToApplicationId eq ${appIds[0]})) and showOnMarketplace eq true`
				);
			} else {
				ownParams = ownParams.set(
					'$filter',
					`(FromApplicationId in (${appIds.join(', ')}) or ToApplicationId in (${appIds.join(
						', '
					)})) and showOnMarketplace eq true`
				);
			}
		} else {
			ownParams = ownParams.set('$filter', `showOnMarketplace eq true`);
		}

		return from(this.auth.getPrimaryTokenAsync()).pipe(switchMap(
			pt => this.http.get(pathJoin([this.auth.userSession.backend.odataBaseUrl, 'dynamic/_AL3_vw_marketplaceitem']), {
				headers: skipAuthInterceptor(new HttpHeaders().set('Authorization', 'Bearer ' + pt)),
				params: ownParams,
			})
		),
		// Map to odata value to filter out context
		map((data: any) => data.value));
	}

	public getOne(id: number) {
		let ownParams = new HttpParams();

		ownParams = ownParams.set('$top', 1 + '');

		ownParams = ownParams.set('$filter', `ID eq ${id}`);

		return this.http
			.get(pathJoin([this.auth.userSession.backend.odataBaseUrl, 'dynamic/_AL3_vw_marketplaceitem']), {
				params: ownParams,
			})
			.pipe(map((data: any) => data.value[0]));
	}

	public getFromLink(LinkId: number) {
		let ownParams = new HttpParams();

		ownParams = ownParams.set('LinkId', LinkId.toString());

		return this.http.get<MarketPlaceItem[]>(this.url + '/fromLink', { params: ownParams });
	}
}
